import { render, staticRenderFns } from "./UploadPicComp.vue?vue&type=template&id=2860b586&scoped=true"
import script from "./UploadPicComp.vue?vue&type=script&lang=js"
export * from "./UploadPicComp.vue?vue&type=script&lang=js"
import style0 from "./UploadPicComp.vue?vue&type=style&index=0&id=2860b586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860b586",
  null
  
)

export default component.exports